import React, { useState, useEffect} from "react";
import "../style/dashboard.css";
import { Row, Col, Card, Table, Pagination, Alert, Spinner } from "react-bootstrap";
import HelperFunction from '../util/helper'
import { TIME_FORMAT_OPTIONS } from '../util/constants'
import APIFunction from "../util/api";

export default function Transactions({ preview = false }) {
    const [transactions, setTransactions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const fetchTransactions = async (page) => {
        try {
          setIsLoading(true);
          setError('');
    
          const response = await APIFunction.getUserTransactions(page)
        
          // API should return: { transactions: [], totalPages: number }
          setTransactions(response.data);
          setTotalPages(response.pagination.totalPages);
        } catch (err) {
          setError(err.message);
        } finally {
          setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchTransactions(currentPage);
    }, [currentPage]);
    
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return(
        <Row>
            <Col>
                {error && <Alert variant="danger">{error}</Alert>}
                <Card className="transactions-card">
                    <Card.Body>
                        <div className="card-header-custom">
                            <h5><i className="bi bi-arrow-down-up"></i> Transactions</h5>
                            <select className="filter-select">
                                <option>This Month</option>
                                <option>This Week</option>
                                <option>Today</option>
                            </select>
                        </div>
                        {isLoading ? (
                                <div className="d-flex justify-content-center my-5">
                                    <Spinner animation="border" />
                                </div>
                            ) : (
                                <>
                                    <Table responsive className="transactions-table">
                                        <thead>
                                        <tr>
                                            <th>Transaction Name</th>
                                            <th>Date & Time</th>
                                            <th>Amount</th>
                                            <th>Note</th>
                                            <th>Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {transactions.length > 0 ? (
                                            transactions.map(transaction => (
                                                <tr key={transaction.id}>
                                                <td>
                                                    <div className="transaction-info">
                                                    <strong>{transaction.name}</strong>
                                                    <small className="text-muted d-block">{transaction.category}</small>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="date-time">
                                                    <div>{HelperFunction.formatDate(transaction.created_at, TIME_FORMAT_OPTIONS.DATE_MONTH_YEAR_OPTIONS)}</div>
                                                    <small className="text-muted">{HelperFunction.formatDate(transaction.created_at, TIME_FORMAT_OPTIONS.TIME_OPTIONS)}</small>
                                                    </div>
                                                </td>
                                                <td className={transaction.amount < 0 ? 'amount-negative' : 'amount-positive'}>
                                                    {HelperFunction.formatCurrency(transaction.amount)}
                                                </td>
                                                <td className="note-cell">{HelperFunction.truncateString(transaction.description) ?? 'N/A'}</td>
                                                <td>{HelperFunction.getStatusBadge(transaction.status)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">
                                                    No transactions found.
                                                </td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </Table>

                                    {/* Pagination only if preview === true */}
                                    {!preview && (
                                        <div className="d-flex justify-content-center">
                                            <Pagination>
                                                <Pagination.Prev
                                                    onClick={() => handlePageChange(currentPage - 1)}
                                                    disabled={currentPage === 1}
                                                />
                                                {Array.from({ length: totalPages }, (_, index) => (
                                                    <Pagination.Item
                                                    key={index + 1}
                                                    active={index + 1 === currentPage}
                                                    onClick={() => handlePageChange(index + 1)}
                                                    >
                                                    {index + 1}
                                                    </Pagination.Item>
                                                ))}
                                                <Pagination.Next
                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                    disabled={currentPage === totalPages}
                                                />
                                            </Pagination>
                                        </div>)
                                    }
                                </>
                            )}
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}